import enumeration from "./enumeration";

const CreditExpirationType = {
  NeverExpiresAfterCheckout: "NEVER_EXPIRES_AFTER_CHECKOUT",
  AutomaticallyExpiresAfterCheckout: "AUTOMATICALLY_EXPIRES_AFTER_CHECKOUT",
};

export default enumeration(CreditExpirationType);
